import React, { useState } from 'react';
import { PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQSection() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="faq" className="w-full bg-white" data-id="element-62" data-mp="1iw858cj120w2">
      <div className="mx-auto max-w-content px-4 py-14 md:px-8 md:py-20" data-id="element-63" data-mp="1ixj90cch38n6">
        <div className="grid gap-8 lg:grid-cols-[0.7fr_1.3fr] lg:gap-14" data-id="element-64" data-mp="1nvt7avthupd0">
          <h2 className="font-display text-[26px] font-semibold leading-[1.12] tracking-[-0.025em] text-ink md:text-[38px]" data-id="element-65" data-mp="2bju9ln02x9jz">
            Questions agents ask first.
          </h2>

          <div className="divide-y divide-line border-y border-line" data-id="element-66" data-mp="21ukf60hrjesp">
            {faqs.map((faq, i) => {
            const expanded = open === i;
            return <div key={faq.question} data-id="element-67" data-mp="26rj6kba1l7n7" data-mpi={i}>
                  <h3 data-id="element-68" data-mp="2uiomsrjwa1y1">
                    <button type="button" onClick={() => setOpen(expanded ? null : i)} aria-expanded={expanded} aria-controls={`faq-panel-${i}`} className="flex w-full items-start justify-between gap-4 py-5 text-left transition-colors duration-150 ease-smooth hover:text-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent" data-id="element-69" data-mp="2uigab0rooynd">
                      <span className="font-display text-[17px] font-semibold leading-snug tracking-[-0.015em] text-inherit md:text-[19px]" data-id="element-70" data-mp="20om6aym3e5ne">
                        {faq.question}
                      </span>
                      <PlusIcon className={`mt-0.5 h-5 w-5 shrink-0 text-ink-400 transition-transform duration-200 ease-smooth ${expanded ? 'rotate-45' : ''}`} aria-hidden="true" data-id="element-71" data-mp="2adm7moo2hd4r" />
                    </button>
                  </h3>
                  {expanded && <div id={`faq-panel-${i}`} className="pb-6 pr-8" data-id="element-72" data-mp="p244m3xvy2hf">
                      <p className="max-w-2xl text-[15px] leading-relaxed text-ink-600 md:text-[16px]" data-id="element-73" data-mp="2p3tzeimk1uq1">{faq.answer}</p>
                    </div>}
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}